export enum MedicineStatus {
  Green = 0,
  Yellow = 1,
  Red = 2,
}
